export default "__VITE_ASSET__DDDExR4t__"